import { useState } from "react";
import {
  Box, Tabs, TabList, TabPanels, Tab, TabPanel,
} from "@chakra-ui/react";
import FeatureGate from "components/FeatureGate";
import NudgeTemplatesList from "./NudgeTemplatesList";
import NudgePreferences from "./NudgePreferences";
import AvailableTemplates from "./AvailableTemplates";
import AppPage from "layouts/AppPage";

export default function NudgesSettings() {
  const [tabIndex, setTabIndex] = useState(0);

  const handleTemplateAdded = () => {
    // Switch to preferences tab after adding a template
    setTabIndex(0);
    // The preferences query will automatically refetch due to invalidation
  };

  return (
    <AppPage>
      <FeatureGate feature="nudges_system">
        <Box bg="gray.50" minH="100vh" p={6}>
          <Box maxW="1200px" mx="auto">
            <Tabs colorScheme="blue" index={tabIndex} onChange={setTabIndex}>
              <TabList bg="white" borderRadius="md" mb={4}>
                <Tab>My Preferences</Tab>
                <Tab>Available Templates</Tab>
                <Tab>Custom Templates</Tab>
              </TabList>

              <TabPanels>
                <TabPanel bg="white" borderRadius="md">
                  <NudgePreferences />
                </TabPanel>
                <TabPanel bg="white" borderRadius="md">
                  <AvailableTemplates onTemplateAdded={handleTemplateAdded} />
                </TabPanel>
                <TabPanel bg="white" borderRadius="md">
                  <NudgeTemplatesList />
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Box>
        </Box>
      </FeatureGate>
    </AppPage>
  );
}
